import React, { FC } from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';

import { ALL_MOBILE_ROUTES } from '@webtrader/core/router/mobile.web';

import { BaseSafeAreaView } from '@/components/Screen/SafeAreaView';
import DemoCompletionScreen from '@/screens/auth/DemoCompletion';
import DemoCreationScreen from '@/screens/auth/DemoCreation';
import ExperienceDemoCompletionScreen from '@/screens/auth/ExperienceDemo/ExperienceDemoCompletionScreen';
import ExperienceDemoCreationScreen from '@/screens/auth/ExperienceDemo/ExperienceDemoCreationScreen';
import ExperienceDemoResetPasswordScreen from '@/screens/auth/ExperienceDemo/ExperienceDemoResetPasswordScreen';
import LoginScreen from '@/screens/auth/Login';
import ResetPassword from '@/screens/auth/PasswordReset';
import SignUpScreen from '@/screens/auth/SignUp';

interface IProps {}

const AuthenticationNavigation: FC<IProps> = () => {
  return (
    <BaseSafeAreaView>
      <Switch>
        <Route path={ALL_MOBILE_ROUTES.AUTH.LOGIN} component={LoginScreen} exact={true} />
        <Route path={ALL_MOBILE_ROUTES.AUTH.SIGN_UP} component={SignUpScreen} exact={true} />
        <Route path={ALL_MOBILE_ROUTES.AUTH.RESET_PASSWORD} component={ResetPassword} exact={true} />
        <Route path={ALL_MOBILE_ROUTES.AUTH.DEMO_CREATION} component={DemoCreationScreen} exact={true} />
        <Route path={ALL_MOBILE_ROUTES.AUTH.DEMO_COMPLETION} component={DemoCompletionScreen} exact={true} />
        <Route
          path={ALL_MOBILE_ROUTES.AUTH.EXPERIENCE_DEMO_CREATION}
          component={ExperienceDemoCreationScreen}
          exact={true}
        />
        <Route
          path={ALL_MOBILE_ROUTES.AUTH.EXPERIENCE_DEMO_COMPLETION}
          component={ExperienceDemoCompletionScreen}
          exact={true}
        />
        <Route
          path={ALL_MOBILE_ROUTES.AUTH.EXPERIENCE_DEMO_RESET_PASSWORD}
          component={ExperienceDemoResetPasswordScreen}
          exact={true}
        />
        <Redirect to={ALL_MOBILE_ROUTES.AUTH.LOGIN} />
      </Switch>
    </BaseSafeAreaView>
  );
};

export default AuthenticationNavigation;
